import React from 'react';
import {
  Redirect
} from 'react-router-dom'
import {connect} from "react-redux";
import * as actionCreators from "../../actions/index.js"
import Login from "../../component/auth/login.js";

class Logincon extends React.Component{
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.toRegister = this.toRegister.bind(this);
    this.state = {
        submitted: false
    };
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  toRegister(event) {
    this.props.history.replace('/register');
  }

  handleFormSubmit(e){
    e.preventDefault();
    this.setState({ submitted: true}, () => {
      this.props.loginAction(this.state.email,this.state.password)
      .then(res => {
        //
      })
      .catch(err => {
        this.setState({
          submitted: false
        })
      })

    });
  }

  componentWillMount() {
    if (this.props.isLoggedIn) {
      this.props.history.replace('/');
    }
  }

  render(){
    if (this.props.isLoggedIn) {
      return(<Redirect to="/" />)
    }
    return <Login submitted={this.state.submitted} handleFormSubmit={this.handleFormSubmit} handleChange={this.handleChange} toRegister={this.toRegister} user={this.props.user}></Login>
  }
}

const mapStateToProps=(state)=>{
    return state
};

export default connect (mapStateToProps, actionCreators)(Logincon);



// WEBPACK FOOTER //
// ./src/container/auth/login-container.js